exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.dataBox{\n  background-color: #fff;\n  margin:  15px 5px;\n  padding:30px 34px 26px;\n}\n", "", {"version":3,"sources":["/var/jenkins_home/workspace/xiancun admin/src/App.vue"],"names":[],"mappings":";AAaA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;CACxB","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n.dataBox{\n  background-color: #fff;\n  margin:  15px 5px;\n  padding:30px 34px 26px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = z/+d
// module chunks = 91